// Mock data for Unisol Global website
export const mockData = {
  company: {
    name: "Unisol Global",
    tagline: "Premium Automotive Excellence",
    locations: ["Bangalore, India"],
    established: "25+ Years of Excellence"
  },
  
  founder: {
    name: "Nirmal Narayan",
    title: "Founder & Automotive Expert",
    experience: "25 Years",
    studentsTrained: "100+",
    specializations: [
      "Authorized Trainer for Rupes, Italy",
      "Bigfoot Polishing System Expert",
      "Premium PPF Specialist",
      "Business Mentor"
    ],
    bio: "With over 25 years of experience in the automotive industry, Nirmal has established himself as a leading authority in premium automotive detailing and paint protection. As an authorized trainer for Rupes, Italy, he has trained over 100 professional detailers across India and mentored numerous successful businesses."
  },

  services: [
    {
      id: 1,
      title: "Paint Protection Film (PPF)",
      description: "Premium PPF specially designed for Indian conditions. Invisible protection that maintains your vehicle's pristine appearance.",
      features: ["Self-healing technology", "UV resistance", "10-year warranty", "Custom installation"],
      icon: "Shield"
    },
    {
      id: 2,
      title: "Ceramic Coating",
      description: "Advanced nano-ceramic coatings providing long-lasting protection and enhanced gloss.",
      features: ["Hydrophobic protection", "Scratch resistance", "Enhanced durability", "Professional application"],
      icon: "Sparkles"
    },
    {
      id: 3,
      title: "Graphene Coating",
      description: "Next-generation graphene technology for superior protection and performance.",
      features: ["Thermal conductivity", "Enhanced durability", "Water repelling", "Anti-static properties"],
      icon: "Zap"
    },
    {
      id: 4,
      title: "Premium Detailing",
      description: "Complete automotive detailing services for luxury and premium vehicles.",
      features: ["Interior detailing", "Exterior correction", "Engine bay cleaning", "Leather treatment"],
      icon: "Car"
    },
    {
      id: 5,
      title: "Body Shop Services",
      description: "Professional body repair and refinishing services with OEM standards.",
      features: ["Collision repair", "Paint matching", "Dent removal", "Quality assurance"],
      icon: "Wrench"
    },
    {
      id: 6,
      title: "Mechanical Services",
      description: "Comprehensive mechanical services for all premium automotive brands.",
      features: ["Diagnostics", "Preventive maintenance", "Performance tuning", "Expert technicians"],
      icon: "Settings"
    }
  ],

  training: {
    title: "Professional Training Center",
    description: "Become a certified automotive detailing professional with our comprehensive training programs.",
    programs: [
      {
        id: 1,
        name: "Professional Detailing Certification",
        duration: "2 Weeks",
        price: "₹40,000",
        description: "Complete training in automotive detailing techniques and business setup",
        modules: ["Paint correction", "Ceramic coating application", "PPF Installation", "Sunfilm installation", "Business planning", "Customer service"]
      },
      {
        id: 2,
        name: "Installation Mastery",
        duration: "1 Week",
        price: "₹20,000",
        description: "Specialized training in PPF and sunfilm installation techniques",
        modules: ["PPF handling", "Sunfilm installation", "Pattern cutting", "Installation techniques", "Quality control", "Surface preparation"]
      },
      {
        id: 3,
        name: "Rupes Polishing System",
        duration: "3 Days",
        price: "₹15,000",
        description: "Official Rupes training program for polishing and correction",
        modules: ["Machine operation", "Product selection", "Technique mastery", "Safety protocols"]
      }
    ],
    benefits: [
      "Certified by industry experts",
      "Hands-on practical training",
      "Business mentorship included",
      "Job placement assistance",
      "Ongoing support network"
    ]
  },

  testimonials: [
    {
      id: 1,
      name: "Rajesh Kumar",
      role: "Certified Detailer, Mumbai",
      content: "Nirmal's training transformed my career. The practical knowledge and business guidance helped me establish my own successful detailing center.",
      rating: 5
    },
    {
      id: 2,
      name: "Priya Sharma",
      role: "PPF Specialist, Delhi",
      content: "The PPF installation course was incredibly detailed. The techniques I learned here are unmatched in the industry.",
      rating: 5
    },
    {
      id: 3,
      name: "Rajesh Kumar",
      role: "Business Owner, Chennai",
      content: "Unisol Global's products and training gave me the confidence to start my premium detailing business.",
      rating: 5
    }
  ],

  gallery: [
    {
      id: 1,
      title: "PPF Installation",
      category: "services",
      description: "Professional PPF installation on luxury vehicles"
    },
    {
      id: 2,
      title: "Training Session",
      category: "training",
      description: "Students learning ceramic coating techniques"
    },
    {
      id: 3,
      title: "Detailed Results",
      category: "services",
      description: "Before and after detailing showcase"
    }
  ],

  blogs: [
    {
      id: 1,
      title: "The Future of Paint Protection Films in India",
      excerpt: "Exploring how PPF technology is revolutionizing vehicle protection in Indian conditions...",
      author: "Nirmal Narayan",
      date: "2024-01-15",
      readTime: "5 min"
    },
    {
      id: 2,
      title: "Building a Successful Detailing Business",
      excerpt: "Key strategies and insights for entrepreneurs entering the automotive detailing industry...",
      author: "Nirmal Narayan",
      date: "2024-01-10",
      readTime: "8 min"
    },
    {
      id: 3,
      title: "Ceramic vs Graphene: Which Coating is Right for You?",
      excerpt: "A comprehensive comparison of modern coating technologies and their applications...",
      author: "Nirmal Narayan",
      date: "2024-01-05",
      readTime: "6 min"
    }
  ],

  tuning: {
    title: "Professional Tuning Services",
    description: "Unlock your vehicle's true potential with our expert tuning and performance optimization services.",
    heroImage: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80",
    services: [
      {
        id: 1,
        name: "Speed Chime Removal",
        description: "Remove annoying speed warning chimes and customize your vehicle's alert system",
        features: [
          "Complete speed chime removal",
          "Customizable alert settings", 
          "Reversible modifications",
          "No warranty void procedures"
        ],
        duration: "2-3 hours",
        price: "Starting from ₹8,000",
        image: "https://images.unsplash.com/photo-1616540258607-4ef63d41653b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxjYXIlMjBzcGVlZG9tZXRlcnxlbnwwfHx8fDE3NTg4MDg3NTR8MA&ixlib=rb-4.1.0&q=85",
        popular: true
      },
      {
        id: 2, 
        name: "ECU Remapping",
        description: "Optimize engine performance with custom ECU tuning for better power and efficiency",
        features: [
          "Custom ECU calibration",
          "Power and torque enhancement",
          "Improved fuel economy",
          "Professional dyno testing"
        ],
        duration: "1-2 days",
        price: "Starting from ₹25,000",
        image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
      },
      {
        id: 3,
        name: "Performance Tuning",
        description: "Complete vehicle performance optimization for maximum power output",
        features: [
          "Engine optimization",
          "Suspension tuning", 
          "Exhaust system enhancement",
          "Custom performance mapping"
        ],
        duration: "2-3 days",
        price: "Starting from ₹50,000",
        image: "https://images.unsplash.com/photo-1503736334956-4c8f8e92946d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
      },
      {
        id: 4,
        name: "Diagnostic Services",
        description: "Advanced vehicle diagnostics and troubleshooting for all systems",
        features: [
          "Full system diagnostics",
          "Error code analysis",
          "Performance testing",
          "Preventive maintenance"
        ],
        duration: "2-4 hours",
        price: "Starting from ₹5,000",
        image: "https://images.unsplash.com/photo-1746079074494-822fb0f83364?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxtZWNoYW5pYyUyMGluc3BlY3RpbmclMjBjYXJ8ZW58MHx8fHwxNzU4ODA4OTg5fDA&ixlib=rb-4.1.0&q=85"
      }
    ],
    serviceTypes: [
      "speed_chime_removal",
      "ecu_remapping", 
      "performance_tuning",
      "diagnostic_services",
      "exhaust_tuning",
      "suspension_setup",
      "other"
    ],
    urgencyOptions: [
      { value: "urgent", label: "Urgent (Within 1-2 days)" },
      { value: "normal", label: "Normal (Within 1 week)" },
      { value: "flexible", label: "Flexible (Anytime)" }
    ],
    budgetRanges: [
      "Under ₹10,000",
      "₹10,000 - ₹25,000", 
      "₹25,000 - ₹50,000",
      "₹50,000 - ₹1,00,000",
      "Above ₹1,00,000",
      "Need consultation"
    ]
  },

  contact: {
    bangalore: {
      address: "No. 13, SH 104, Maruthi Nagar, Yelahanka, Bangalore - 560064",
      phone: "+91 9916120561 / +91 9900886888",
      email: "unisol.globalai@gmail.com"
    },
    hours: "Mon-Sat: 9:30 AM - 6:00 PM"
  }
};